import { render } from "./lidaMenu.vue?vue&type=template&id=be269592&scoped=true"
import script from "./lidaMenu.vue?vue&type=script&lang=js"
export * from "./lidaMenu.vue?vue&type=script&lang=js"

import "./lidaMenu.vue?vue&type=style&index=0&id=be269592&scoped=true&lang=less"
import "./lidaMenu.vue?vue&type=style&index=1&id=be269592&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be269592"]])

export default __exports__